<template>
  <div class="col">
    <div id="main"
             class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title"> <span v-if="siteArea === 'adults'">Adult</span> <span v-else>Colts</span> fixtures and results from {{year}} </h2>
              <!-- Text -->
              <p>Fixtures for the {{ year }} season:</p>
            </div>
            <div class="col-12 col-lg-12">
              <div class="accordion"
                                 id="accordion-2018-fixtures-results">
                <div v-for="(team, firstIndex) in fixtures[siteArea]"
                                     v-bind:key="firstIndex"
                                     class="card">
                  <div class="card-header"
                                         id="headingOne"
                                         v-b-toggle="'accordion-' + firstIndex">
                    <h5 class="mb-0">
                      <button class="btn"> {{team.name}} </button>
                    </h5>
                  </div>
                  <b-collapse :id="'accordion-' + firstIndex"
                                                visible
                                                accordion="my-accordion"
                                                role="tabpanel">
                    <div class="collapse show">
                      <div class="card-body">
                        <h6>{{team.description}}</h6>
                        <div class="row justify-content-center">
                          <div class="col-12 cricket-seasons">
                            <div v-for="(month, secondIndex) in fixtures[siteArea][firstIndex].games"
                                                             v-bind:key="secondIndex"
                                                             class="" :class="{['season'+month.year]: true}">
                              <div class="list-group mb-4 seasondates">
                                <b-collapse :id="'accordion-year-' + secondIndex"
                                                
                                                accordion="year-accordion"
                                                role="tabpanel" v-for="match in month.matches"
                                                                 v-bind:key="match._id"
                                                                 class="list-group-item list-group-item-action p-3 collapse show">
                                  <div class="row align-items-center">
                                    <div class="col-xs-12 col-sm border-right">
                                      <p class="text-muted has-icon-left justify-content-md-end"> <i class="material-icons icon-2 m-0 p-1">schedule</i> <span><span>{{match.readableDate}}</span> @ <span>{{match.time}}</span></span> </p>
                                      <hgroup class="my-2">
                                        <h6 class="m-0 p-0">Ealing Trailfinders <span>vs</span></h6>
                                        <h4 class="m-0 p-0 text-uppercase"> {{match.opposition}}</h4>
                                      </hgroup>
                                      <div class="list-inline-item has-icon-left"> <span v-if="match.result === 'Won'"
                                                                                  class="badge badge-success badge-round mr-2"><i class="material-icons icon-2 m-0 p-1">thumb_up</i></span> <span v-else-if="match.result === 'Lost'"
                                                                                  class="badge badge-danger badge-round mr-2"><i class="material-icons icon-2 m-0 p-1">thumb_down</i></span> <span v-else-if="match.result === 'Cancelled'"
                                                                                  class="badge badge-dark badge-round mr-2"><i class="material-icons icon-2 m-0 p-1">clear</i></span> <span v-else
                                                                                  class="badge badge-dark badge-round mr-2"><i class="material-icons icon-2 m-0 p-1">thumbs_up_down</i></span> <span class="text-strong text-uppercase mr-2 pr-2 border-right">{{match.fixture}}</span> <span class="">{{match.score}}</span> </div>
                                    </div>
                                    <div class="col-auto ml-auto">
                                      <button v-b-modal="'modal-' +  match._id"
                                                                                class="btn-more btn-more-outline btn-more-sm btn-has-icon-left"> <i class="material-icons p-1">keyboard_arrow_right</i> Report </button>
                                    </div>
                                    <b-modal :id="'modal-' + match._id"
                                                                             title="Match Report"
                                                                             content-class="shadow"
                                                                             size="lg"
                                                                             hide-footer
                                                                             hide-backdrop>
                                      <p class="my-4"
                                                                           v-html="match.report">{{match.report}}</p>
                                    </b-modal>
                                  </div>
                                </b-collapse>
                                <div :id="'accordion_trigger_' + secondIndex" class="list-group-item p-3 list-group-item-info plusminus" v-b-toggle="'accordion-year-' + secondIndex">
                                  <p class="justify-content-end has-icon-right text-strong"> {{month.month}} {{month.year}} <i class="material-icons icon-3">today</i> </p>
                                </div>
                              </div>
                            </div>
                            <!--second-index--> 
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {fetchFixtures} from "@/services/api";
    import {fetchFixOrder} from "@/services/fixOrder";
    import EventBus from '../eventBus'
    export default {
        data() {
            return {
                siteArea: null,
                year: "",
                fixtures: {
                    adults: [],
                    juniors: []
                },
            }	
        },
        created() {
            this.siteArea = this.$route.query.team;
            this.fetchList();
        },
        mounted(){
            EventBus.$on("get-year", (year) => {
                this.year = year
            })
			setTimeout(function(){ 
                    const elem = document.getElementById('accordion_trigger_4');
                    elem.click(); 
                }, 300);
        },
        methods: {
            fetchList() {
                fetchFixtures()
                    .then(async (response) => {

                        if (this.siteArea === 'adults') {

                            let adultResults = [];

                            for (let value of response) {

                                if (value.age === 'Adult' && value.status === 'Live') {
                                    let fixtureObj = {};
									
                                    fixtureObj.name = value.team;
                                    fixtureObj.games = [];
                                    if (value.team === '1st XI') {
                                        fixtureObj.sort = 1;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2022 - Division Two';
                                    }
                                    if (value.team === '2nd XI') {
                                        fixtureObj.sort = 2;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division Two';
                                    }
                                    if (value.team === '3rd XI') {
                                        fixtureObj.sort = 3;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division Five B';
                                    }
                                    if (value.team === '4th XI') {
                                        fixtureObj.sort = 4;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division Six B';
                                    }
                                    if (value.team === '1st Sunday XI') {
                                        fixtureObj.sort = 5;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division Six B';
                                    }
                                    if (value.team === '1st Sunday Friendly XI') {
                                        fixtureObj.sort = 6;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2020 - Division Six B';
                                    }

                                    // We check to see if a team has been created
                                    for (let object of adultResults) {
                                        if (object.name === value.team) {
                                            object.games.push(value);
                                            fixtureObj = null;
                                            break;
                                        }
                                    }
                                    // If the team has not been created then we create it in results
                                    if (fixtureObj) {
                                        fixtureObj.games.push(value);
                                        // fixtureObj.games = await this.breakByDate(fixtureObj.games);
                                        adultResults.push(fixtureObj);
                                    }
                                }
                            }

                            for (let value of adultResults) {
                                value.games = await this.breakByDate(value.games);
                            }
                            this.fixtures.adults = adultResults.sort((a, b) => a.sort - b.sort);
                        }

                        if (this.siteArea === 'juniors') {

                            let juniorResults = [];

                            for (let value of response) {

                                if (value.age === 'Junior' && value.status === 'Live') {
                                    let fixtureObj = {};
                                    fixtureObj.name = value.team;
                                    fixtureObj.games = [];

                                    if (value.team === 'Colts u8s') {
                                        fixtureObj.sort = 1;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2022 - Division One';
                                    }
                                    if (value.team === 'Colts u10s') {
                                        fixtureObj.sort = 2;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division One';
                                    }
                                    if (value.team === 'Colts u13s') {
                                        fixtureObj.sort = 3;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division One';
                                    }
                                    if (value.team === 'Colts u13s') {
                                        fixtureObj.sort = 4;
                                        fixtureObj.description = 'Middlesex Championship: Fixtures Season 2021 - Division One';
                                    }

                                    // We check to see if a team has been created
                                    for (let object of juniorResults) {
                                        if (object.name === value.team) {
                                            object.games.push(value);
                                            fixtureObj = null;
                                            break;
                                        }
                                    }
                                    // If the team has not been created then we create it in results
                                    if (fixtureObj) {
                                        fixtureObj.games.push(value);
                                        juniorResults.push(fixtureObj);
                                    }
                                }
                            }

                            for (let value of juniorResults) {
                                value.games = await this.breakByDate(value.games);
                            }
                            this.fixtures.juniors = juniorResults.sort((a, b) => a.sort - b.sort);
                        }
                    })
            },
            async breakByDate(_fixtures) {
                let results = [];
                let fixturesByDate = _fixtures.sort((a, b) => new Date(b.date) - new Date(a.date));

                for (let value of fixturesByDate) {

                    let day = new Date(value.date).toLocaleString('default', {day: '2-digit'});
                    let month = new Date(value.date).toLocaleString('default', {month: 'long'});
                    let year = new Date(value.date).getFullYear();

                    let monthObj = {};
                    monthObj.month = month;
                    monthObj.year = year;
                    monthObj.matches = [];
                    value.readableDate = day + ' ' + month + ' ' + year;

                    // We check to see if a month of matches has been created
                    for (let object of results) {
                        if (object.month === month && object.year === year) {
                            object.matches.push(value);
                            monthObj = null;
                            break;
                        }
                    }
                    // If there have not been any matches yet under a specific date we make a new object
                    if (monthObj) {
                        monthObj.matches.push(value);
                        results.push(monthObj);
                    }
                }
                return results;
				
            }
        }
    }
fetchFixOrder()
</script>
<style scoped>
    button .btn {
        background: red !important;
    }
	.plusminus:before {
    float: left;
    font-family: Material-Design-Iconic-Font;
    content:"\f273";
    padding-right: 5px;
}
.plusminus.collapsed:before {
    float: left;
    content:"\f278";
}
.cricket-seasons{ display: flex; flex-direction:column-reverse; }
.seasondates{display: flex; flex-direction:column-reverse; }
.season2022 { order:3;}
.season2021 { order: 2; }
.season2020 { order: 1; }
</style>
